export const ERROR_CODES = {
    USER_DOES_NOT_EXIST: '9924',
    USER_DOES_NOT_EXIST_CODE: 'USER_DOES_NOT_EXIST',
    EXPIRED_TOKEN: '9006',
    EXPIRED_IDENTITY_TOKEN: '9503',
    EMAIL_ALREADY_VERIFIED: '9911',
    VERIFICATION_TOKEN_EXPIRED: '9906'

};
